import { render } from "./OnScreenDebuggerGeneralTab.vue?vue&type=template&id=126e44c9&scoped=true&ts=true"
import script from "./OnScreenDebuggerGeneralTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnScreenDebuggerGeneralTab.vue?vue&type=script&setup=true&lang=ts"

import "./OnScreenDebuggerGeneralTab.vue?vue&type=style&index=0&id=126e44c9&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126e44c9"],['__file',"src/components/OnScreenDebuggerGeneralTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "126e44c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('126e44c9', __exports__)) {
    api.reload('126e44c9', __exports__)
  }
  
  module.hot.accept("./OnScreenDebuggerGeneralTab.vue?vue&type=template&id=126e44c9&scoped=true&ts=true", () => {
    api.rerender('126e44c9', render)
  })

}


export default __exports__